import { FormGroup, Input, Label } from 'reactstrap';
import { Camera24 } from '@bphxd/ds-core-react/lib/icons';
import joinSigningFormClasses from '../../pages/JointDetails/JointSigningForm.module.scss';
import { FC } from 'react';

const FileUploadButton: FC<{
  onFileSelect: (files: FileList) => void;
}> = ({ onFileSelect }) => (
  <FormGroup className={joinSigningFormClasses.uploadBtn}>
    <Label for="media-file">
      <Camera24 /> Add Attachment
    </Label>
    <Input
      id="media-file"
      type="file"
      placeholder="Add file"
      onClick={(event) => ((event.target as any).value = null)}
      onChange={(e) => onFileSelect((e.target as HTMLInputElement)?.files || new FileList())}
    />
  </FormGroup>
);

export default FileUploadButton;
